import { Endpoint } from '@App/app/entities/auth/endpoint.model';
import { UserPermissions } from '@App/app/entities/auth/permissions.enum';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The searchable company list plus the admin-panel entry, shared by the
 * full-page company selection and the company selection drop-down. The two
 * consumers reuse this structure and apply their own context-specific styling.
 */
@Component({
  selector: 'app-company-selection-list',
  templateUrl: './company-selection-list.component.html',
  styleUrls: ['./company-selection-list.component.scss'],
})
export class CompanySelectionListComponent {
  @Input() endpoints: Endpoint[];
  @Input() searchInputId?: string;
  @Output() selectCompany = new EventEmitter<Endpoint>();
  @Output() adminPanelClick = new EventEmitter<void>();
  searchText: string;
  permissions = UserPermissions;
}
